import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AllEpisodesPage from "./pages/AllEpisodesPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/plugin-cafe" element={<AllEpisodesPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
